<template>
	<div>
		<h2 class="heading-5 mt-150"> All updates on this asset </h2>
		<div class="mt-100">
			<div
				v-for="(associatedUpdate, index) in props.allUpdates"
				:key="index"
				class="simple-timeline__item delta-md heading-text-color"
				:class="{
					'simple-timeline__item--active': associatedUpdate.fundriseId === props.investorUpdateId,
					'simple-timeline__item--second-and-only': index === 1 && props.allUpdates.length === 2
				}"
			>
				<BaseLink
					v-if="associatedUpdate.fundriseId !== props.investorUpdateId"
					:link="{ router: 'investor-update', params: { investorUpdateId: associatedUpdate.fundriseId } }"
					class="text-color-current-color"
				>
					<span v-html="associatedUpdate.title"></span>
				</BaseLink>
				<span v-else> {{ associatedUpdate.title }}</span>

				<div class="muted zeta">
					{{ date(associatedUpdate.displayDate) }}
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { date } from '@filters/shared-filters';
import { InvestorUpdatePreview } from 'types/account';

interface Props {
	allUpdates: Array<InvestorUpdatePreview>;
	investorUpdateId: string;
}

const props = defineProps<Props>();
</script>
